import router from "@/router";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import './assets/css/design_version.css'

import { createApp } from 'vue'
import App from './App.vue'
import store from './store/index.js';

const app = createApp(App);
app.use(router);
app.use(store);
app.mount('#app');
export { app };